import mergeObject from '../utils/merge-object';

import timelineRequest from './timeline-request';

/**
 * Initialises the component when passed an element
 *
 * @param {Element} rootElement The component dom node
 * @param {object} options Optional parameters for component
 */
export default function(rootElement, options) {
  if (!rootElement) {
    return;
  }

  const config = {
    url: null,
    interval: 15,
    fetchPolyfill: 'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=Array.from%2CArray.prototype.includes%2Cfetch',
    templates: rootElement.querySelectorAll("[data-type='text-template']")
  };

  // merge passed options into config
  mergeObject(config, options);

  // bail out if no template defined
  if (!config.templates || config.templates.length <= 0) {
    return;
  }

  timelineRequest(rootElement, config);
}
